import React from "react";
import { Container } from "react-bootstrap";
import classes from './linkBlock.module.css';
import OptionBlock from "./optionBlock";

const OptionList4 = ({options, title}) => {
    return (
        <Container fluid="md">
            <h3 style={{textAlign: 'center'}}>{title}</h3>
            <div className={classes.optionList4}>
                {options.map((option, index) =>
                    <OptionBlock number={index +1} option={option} key={option.id} />
                )}
            </div>
        </Container>
    )
}

export default OptionList4;